import { useEffect, useState } from 'react';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import OnboardingWelcomeModal from './OnboardingWelcomeModal';
import OnboardingCompletionModal from './OnboardingCompletionModal';

const OnboardingTrigger = () => {
  const { hasCompletedOnboarding, isOnboardingActive, showCompletionModal, hideCompletionModal } = useOnboarding();
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    // Hide welcome modal if completion modal is showing
    if (showCompletionModal) {
      setShowWelcomeModal(false);
      return;
    }

    // Show welcome modal if user hasn't completed onboarding and is not currently in onboarding
    if (!hasCompletedOnboarding && !isOnboardingActive) {
      // Delay showing the modal slightly to allow page to render
      const timer = setTimeout(() => {
        setShowWelcomeModal(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [hasCompletedOnboarding, isOnboardingActive, showCompletionModal]);

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
  };

  const handleCloseCompletionModal = () => {
    hideCompletionModal();
  };

  return (
    <>
      <OnboardingWelcomeModal
        open={showWelcomeModal}
        onClose={handleCloseWelcomeModal}
      />
      <OnboardingCompletionModal
        open={showCompletionModal}
        onClose={handleCloseCompletionModal}
      />
    </>
  );
};

export default OnboardingTrigger;
